<div class="container">
  <div class="footer">
    <div class="link-container">
      <div class="weblink" (click)="goToFC()">
        <span>LandYield.com</span>
        <fa-icon [icon]="['fas', 'arrow-up-right-from-square']"></fa-icon>
      </div>
      <div (click)="navigate('/legal/privacy-policy')" class="weblink">Privacy Policy</div>
      <div (click)="navigate('/legal/terms-and-conditions')" class="weblink">Terms & Conditions</div>
    </div>
    <div class="contact">
      <span>Questions?</span>
      <a href="tel:{{ helpPhone }}" target="_blank" rel="noopener noreferrer">
        <fa-icon [icon]="['fal', 'phone']"></fa-icon>
        <span>{{ helpPhone }}</span>
      </a>
      <a href="mailto:{{ helpEmail }}" target="_blank" rel="noopener noreferrer">
        <fa-icon [icon]="['fal', 'envelope']"></fa-icon>
        <span>{{ helpEmail }}</span>
      </a>
    </div>
  </div>
</div>
